import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ICategorySFilter } from 'src/@types/SearchFilterTypes';
import { Page } from 'src/components/Page';

import { CategoryGrid } from './CategoryGrid';
import SearchForm from './SearchForm';

/**
 * ## Category 설명
 * - 카테고리 관리 페이지
 * - 카테고리 목록 조회, 등록, 수정, 삭제
 * - depth 1 최상위 카테고리
 * - depth 2 이상 하위 카테고리 추가 가능
 * */

const Category = () => {
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<ICategorySFilter>>({});

  // 목록 검색
  const onSearch = (data: ICategorySFilter) => {
    setSearchData(data);
  };

  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <CategoryGrid searchData={searchData} />
    </Page>
  );
};

export default observer(Category);
